<template>
  <div class="phrase-overlay" :style="export_dialog ? 'z-index:300010' : 'z-index:-30000; opacity:0'">
    <transition name="fade">
      <div class="export-dialog list-export-dialog" v-if="export_dialog">
        <div class="newmessage-title">
          <span>
            リストエクスポート
          </span>
          <div class="flex-space"></div>
          <div class="newmessage-button" @click="closeDialog()">
            <font-awesome-icon :icon="['fal', 'times']" />
          </div>
        </div>
        <div class="export-title">
          エクスポートする項目を選択してください
        </div>
        <div class="export-dialog-box">
          <div class="export-subtitle">
            <div>SNS・リストデータ</div>
            <div class="flex-space"></div>
          </div>
          <div class="export-items all">
            <input type="checkbox" class="checkbox-original" @change="checkAll()" v-model="checkAll_val" id="checkAll_item" />
            <label class="checkbox_inner" for="checkAll_item">
              <span style="margin-left:30px; font-weight: 400">全て選択 </span>
            </label>
          </div>
          <div class="export-items" v-for="item in items" :key="item.value">
            <input type="checkbox" class="checkbox-original export" v-model="checkList" :value="item.value" :id="item.value + 'checkbox'" :disabled="item.required" />
            <label class="checkbox_inner export" :for="item.value + 'checkbox'">
              <span style="margin-left:30px">
                {{ item.label }}
              </span>
            </label>
          </div>
        </div>
        <div class="export-dialog-box">
          <div class="export-subtitle">パーソナルデータ</div>
          <div class="export-items all">
            <input type="checkbox" class="checkbox-original" @change="checkAllPersonal()" v-model="checkAllPersonal_val" id="checkAllPersonal_item" />
            <label class="checkbox_inner" for="checkAllPersonal_item">
              <span style="margin-left:30px; font-weight: 400">全て選択 </span>
            </label>
          </div>
          <div class="export-items" v-for="item in personal_items" :key="item.value">
            <input
              type="checkbox" 
              class="checkbox-original export"
              v-model="checkListPersonal" 
              :value="item.value" 
              :id="item.value + 'checkbox'" 
              @change="checkPersonalItem(item.value)" 
              :name="item.value" 
            />
            <label class="checkbox_inner export" :for="item.value + 'checkbox'">
              <span style="margin-left:30px">
                {{ item.label }}
              </span>
            </label>
          </div>
        </div>
        <div class="export-dialog-box" v-show="sns_type == 'instagram'">
          <div class="export-subtitle">レポートデータ</div>
          <div class="export-items all">
            <input type="checkbox" class="checkbox-original" @change="checkAllReport()" v-model="checkAllReport_val" id="checkAllReport_item" />
            <label class="checkbox_inner" for="checkAllReport_item">
              <span style="margin-left:30px; font-weight: 400">全て選択 </span>
            </label>
          </div>
          <div class="export-items" v-for="item in report_items" :key="item.value">
            <input
              type="checkbox" 
              class="checkbox-original export"
              v-model="checkListReport" 
              :value="item.value" 
              :id="item.value + 'checkbox'" 
              @change="checkPersonalItem(item.value)" 
              :name="item.value" 
            />
            <label class="checkbox_inner export" :for="item.value + 'checkbox'">
              <span style="margin-left:30px">
                {{ item.label }}
              </span>
            </label>
          </div>
        </div>
        <div>
          <font-awesome-icon icon="question-circle"/>
          <span style="font-size:11px">エクスポートしたファイルをExcelで開くときにエラーが発生する時は</span>
          <a href="https://help.reech.co.jp/ja/articles/8734117-%E3%82%A8%E3%82%AF%E3%82%B9%E3%83%9D%E3%83%BC%E3%83%88%E3%81%97%E3%81%9F%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E3%82%92excel%E3%81%A7%E9%96%8B%E3%81%8F%E3%81%A8%E3%81%8D%E3%81%AB%E3%82%A8%E3%83%A9%E3%83%BC%E3%81%8C%E7%99%BA%E7%94%9F%E3%81%99%E3%82%8B%E3%81%AE%E3%81%AF%E3%81%AA%E3%81%9C%E3%81%A7%E3%81%99%E3%81%8B" style="color:#0f74df; font-size:11px" target="_blank" rel="noopener noreferrer">こちら</a>
        </div>
        <div class="list-create-footer">
          <div v-if="activate == 11" style="color:#f56c6c; font-size:11px">
            <font-awesome-icon :icon="['fas', 'exclamation-circle']" style="margin-right: 3px;" />
            トライアル版ではエクスポート人数・回数が制限されています。(人数:5人 回数:5回)
          </div>
          <transition name="fade">
            <div style="font-size:11px" v-if="wait_message">
              <font-awesome-icon :icon="['fal', 'exclamation-circle']" style="margin-right: 3px;" />
              データ量が多い場合、エクスポートには数十秒〜数分程度時間がかかる場合があります
            </div>
          </transition>
          <div class="flex-space"></div>
          <el-button @click="closeDialog()">閉じる</el-button>
          <el-button type="primary" @click="exportListDetail()" :disabled="export_loading">
            <div class="flex-row">
              <font-awesome-icon :icon="['fas', 'cloud-download']" style="margin-right:5px" />
              エクスポート
              <div class="loader--mini" v-show="export_loading"></div>
            </div>
          </el-button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API_DOWNLOAD;
const exportListDetailAPI = root + "/api/list/export_list_new";
import FileSaver from "file-saver";

export default {
  name: "listExportDialog",
  props: ["export_dialog", "sns_type", "list_id"],
  components: {},
  data() {
    return {
      checkList: [],
      checkListPersonal: [],
      checkListReport: [],
      instagram_items: [
        { value: "account_name", label: "ユーザー名", required: true, initial: true },
        { value: "name", label: "名前", required: true, initial: true },
        { value: "gender", label: "性別", initial: true },
        { value: "age", label: "年齢" },
        { value: "related_area", label: "関連エリア" },
        { value: "biography", label: "プロフィール", initial: true },
        { value: "followers_count", label: "フォロワー数", required: true, initial: true},
        { value: "following_count", label: "フォロー数"},
        { value: "average_like", label: "平均いいね数", initial: true },
        { value: "average_comments", label: "平均コメント数", initial: true },
        { value: "average_video_play_count", label: "平均リール再生数(合計)" , initial: true },
        { value: "average_video_play_count_organic", label: "平均リール再生数(ｵｰｶﾞﾆｯｸ)" , initial: true },
        { value: "average_video_play_count_pr", label: "平均リール再生数(PR)" , initial: true },
        { value: "average_video_play_rate", label: "平均リール視聴率(合計)" , initial: true },
        { value: "average_video_play_rate_organic", label: "平均リール視聴率(ｵｰｶﾞﾆｯｸ)" , initial: true },
        { value: "average_video_play_rate_pr", label: "平均リール視聴率(PR)" , initial: true },
        { value: "average_engagement_rate", label: "EGR", initial: true },
        { value: "average_engagement_rate_only_pr", label: "EGR(PR投稿のみ)", initial: false },
        { value: "pr_rate", label: "PR率", initial: true },
        { value: "media_frequency", label: "投稿頻度" },
        { value: "media_count", label: "総投稿数" },
        { value: "gender_ratio", label: "フォロワー男女比", initial: true },
        { value: "audience", label: "フォロワー年齢分布" },
        { value: "status", label: "リスト内ステータス" },
        { value: "comment", label: "リスト内コメント" },
        { value: "num", label: "数値" },
        { value: "score", label: "SCORE" },
        { value: "category", label: "関連カテゴリ" },
        { value: "person_title", label: "人物・肩書"},
        { value: "specialty_categories_genres", label: "得意カテゴリー・ジャンル"},
        { value: "post_format", label: "投稿形式"},
        { value: "custom_tag", label: "カスタマイズタグ" },
        { value: "added_list", label: "追加されているリスト" },
        { value: "added_report", label: "追加されているレポート" },
      ],
      youtube_items: [
        { value: "channel_name", label: "チャンネル名", required: true, initial: true },
        { value: "gender", label: "性別", initial: true },
        { value: "description", label: "チャンネル概要", initial: true },
        { value: "subscriberCount", label: "チャンネル登録者数", required: true, initial: true },
        { value: "average_viewCount_3month", label: "平均視聴回数", initial: true },
        { value: "average_viewRate_3month", label: "平均視聴率", initial: true },
        { value: "average_engagementRate_subscriber_3month", label: "エンゲージメント率", initial: true },
        { value: "average_commentCount_3month", label: "平均コメント数", initial: true },
        { value: "prRate", label: "PR率", initial: true },
        { value: "average_postCount_week", label: "投稿頻度" },
        { value: "average_duration", label: "平均動画時間", initial: true },
        { value: "average_likeCount_3month", label: "平均高評価数", initial: true },
        { value: "videoCount", label: "投稿動画数", initial: true },
        { value: "gender_ratio", label: "フォロワー男女比" },
        { value: "audience", label: "フォロワー年齢分布" },
        { value: "status", label: "リスト内ステータス" },
        { value: "comment", label: "リスト内コメント" },
        { value: "num", label: "数値" },
        { value: "category", label: "関連カテゴリ" },
        { value: "custom_tag", label: "カスタマイズタグ" },
        { value: "added_list", label: "追加されているリスト" },
      ],
      tiktok_items: [
        { value: "account_name", label: "ユーザー名", required: true, initial: true },
        { value: "nickname", label: "名前", required: true, initial: true },
        { value: "gender", label: "性別", initial: true },
        { value: "signature", label: "プロフィール", initial: true },
        { value: "followerCount", label: "フォロワー数", required: true, initial: true },
        { value: "heartCount", label: "総いいね数", initial: true },
        { value: "diggCount", label: "平均いいね数" },
        { value: "commentCount", label: "平均コメント数" },
        { value: "shareCount", label: "平均シェア数" },
        { value: "engagementRate", label: "エンゲージメント率", initial: true },
        { value: "playCount", label: "平均視聴回数(合計)", initial: true },
        { value: "playCount_organic", label: "平均視聴回数(ｵｰｶﾞﾆｯｸ)", initial: true },
        { value: "playCount_pr", label: "平均視聴回数(PR)", initial: true },
        { value: "playRate", label: "平均視聴率(合計)", initial: true },
        { value: "playRate_organic", label: "平均視聴率(ｵｰｶﾞﾆｯｸ)", initial: true },
        { value: "playRate_pr", label: "平均視聴率(PR)", initial: true },
        { value: "prRate", label: "PR率", initial: true },
        { value: "media_frequency", label: "投稿頻度" },
        { value: "videoCount", label: "投稿動画数", initial: true },
        { value: "gender_ratio", label: "フォロワー男女比"},
        { value: "audience", label: "フォロワー年齢分布" },
        { value: "status", label: "リスト内ステータス" },
        { value: "comment", label: "リスト内コメント" },
        { value: "num", label: "数値" },
        { value: "score", label: "SCORE" },
        { value: "custom_tag", label: "カスタマイズタグ" },
        { value: "added_list", label: "追加されているリスト" },
      ],
      twitter_items: [
        { value: "account_name", label: "ユーザー名", required: true, initial: true },
        { value: "name", label: "名前", required: true, initial: true },
        { value: "gender", label: "性別", initial: true },
        { value: "description", label: "プロフィール", initial: true },
        { value: "followers_count", label: "フォロワー数", required: true, initial: true },
        { value: "average_like_count", label: "平均いいね数" },
        { value: "average_retweet_sum_count", label: "平均リポスト数" },
        { value: "average_engagement_rate", label: "エンゲージメント率", initial: true },
        { value: "pr_rate", label: "PR率", initial: true },
        { value: "tweet_frequency", label: "投稿頻度" },
        { value: "tweet_count", label: "投稿ポスト数", initial: true },
        // { value: "gender_ratio", label: "フォロワー男女比" },
        { value: "status", label: "リスト内ステータス" },
        { value: "comment", label: "リスト内コメント" },
        { value: "num", label: "数値" },
        { value: "custom_tag", label: "カスタマイズタグ" },
        { value: "added_list", label: "追加されているリスト" },
      ],
      personal_items: [
        { value: "personal_name", label: "氏名" },
        { value: "personal_birthday", label: "生年月日" },
        { value: "personal_zipcode", label: "郵便番号" },
        { value: "personal_address", label: "住所" },
        { value: "personal_bank", label: "振込先" },
        { value: "personal_tel", label: "電話番号" },
        { value: "personal_email", label: "メールアドレス" },
        { value: "personal_belongs", label: "所属" },
        { value: "note", label: "ノート" },
      ],
      report_items: [
        { value: "report_count", label: "起用回数" },
        { value: "avg_report_egr", label: "投稿EG率：平均" },
        { value: "avg_report_reach_count", label: "投稿リーチ数：平均" },
        { value: "avg_report_like_count", label: "投稿いいね数：平均" },
        { value: "avg_report_comments_count", label: "投稿コメント数：平均" },
        { value: "avg_report_saves_count", label: "投稿保存数：平均" },
        { value: "avg_report_cost", label: "投稿コスト：平均" },
      ],
      checkAll_val: false,
      checkAllPersonal_val: false,
      checkAllReport_val: false,
      export_loading: false,
      wait_message: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    permission() {
      return this.$store.state.permission;
    },
    activate() {
      return this.$store.state.activate;
    },
    items() {
      if (this.sns_type == "instagram") return this.instagram_items;
      if (this.sns_type == "youtube") return this.youtube_items;
      if (this.sns_type == "tiktok") return this.tiktok_items;
      if (this.sns_type == "twitter") return this.twitter_items;
      else return [];
    },
  },
  mounted() {},
  methods: {
    resetItems() {
      const newCheckList = [];
      this.checkAll_val = false;
      this.checkAllPersonal_val = false;
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].initial) newCheckList.push(this.items[i].value);
      }
      this.checkList = newCheckList;
      this.checkListPersonal = [];
      this.checkListReport = [];
    },
    closeDialog() {
      this.$emit("update:export_dialog", false);
    },
    checkAll() {
      const newCheckList = [];
      for (let i = 0; i < this.items.length; i++) {
        newCheckList[i] = this.items[i].value;
      }
      if (this.checkAll_val) {
        this.checkList = newCheckList;
      } else {
        if (this.sns_type == "instagram") this.checkList = ["account_name", "name", "followers_count"];
        if (this.sns_type == "youtube") this.checkList = ["channel_name", "subscriberCount"];
        if (this.sns_type == "tiktok") this.checkList = ["account_name", "nickname", "followerCount"];
        if (this.sns_type == "twitter") this.checkList = ["account_name", "name", "followers_count"];
      }
    },
    checkAllPersonal() {
      if (!this.permission.personal_data.access || !this.permission.note.access) {
        this.$store.dispatch("openUnpermittedDrawer", true);
        this.checkAllPersonal_val = false;
        document.getElementById("checkAllPersonal_item").checked = false;
      } else {
        const newCheckList = [];
        var items = this.personal_items;
        for (let i = 0; i < items.length; i++) {
          newCheckList[i] = items[i].value;
        }
        if (this.checkAllPersonal_val) {
          this.checkListPersonal = newCheckList;
        } else {
          this.checkListPersonal = [];
        }
      }
    },
    checkPersonalItem(item) {
      if ((item != "note" && !this.permission.personal_data.access) || (item == "note" && !this.permission.note.access)) {
        this.$store.dispatch("openUnpermittedDrawer", true);
        document.getElementById(item + "checkbox").checked = false;
        for (let i = 0; i < this.checkListPersonal.length; i++) {
          if (this.checkListPersonal[i] == item) {
            this.checkListPersonal.splice(i, 1);
            break;
          }
        }
      }
    },
    checkAllReport() {
      if (!this.permission.report.access) {
        this.$store.dispatch("openUnpermittedDrawer", true);
        this.checkAllReport_val = false;
        document.getElementById("checkAllReport_item").checked = false;
      } else {
        const newCheckList = [];
        var items = this.report_items;
        for (let i = 0; i < items.length; i++) {
          newCheckList[i] = items[i].value;
        }
        if (this.checkAllReport_val) {
          this.checkListReport = newCheckList;
        } else {
          this.checkListReport = [];
        }
      }
    },
    
    exportListDetail() {
      this.export_loading = true;
      setTimeout(() => {
        if (this.export_loading) this.wait_message = true;
      }, 3000);
      this.axios
        .get(exportListDetailAPI, {
          params: {
            list_id: this.list_id,
            variables: JSON.stringify(this.checkList),
            variables_personal: JSON.stringify(this.checkListPersonal),
            variables_report: JSON.stringify(this.checkListReport),
            token: this.token,
            user_token: this.user_token,
          },
        })
        .then((response) => {
          this.export_loading = false;
          this.wait_message = false;
          if (response.data.status == "OK") {
            FileSaver.saveAs(response.data.file, response.data.fileName);
            this.$message({
              message: "「" + response.data.list_name + "」のダウンロードが開始されました",
              type: "success",
              offset: 7,
              showClose: true,
            });
            this.closeDialog();
          } else {
            if (response.data.reason == "trial") {
              this.closeDialog();
              this.$message({
                message: "トライアルでのエクスポート上限回数(5回)に達したため、エクスポートできません",
                type: "error",
                offset: 7,
                showClose: true,
              });
            }
          }
        })
        .catch(() => {
          this.export_loading = false;
          this.wait_message = false;
        });
      // location.href =
      //   exportListDetailAPI + "?token=" + this.token + "&list_id=" + this.list_id + "&variables=" + JSON.stringify(this.checkList) + "&variables_personal=" + JSON.stringify(this.checkListPersonal);
    },
    getFileName(contentDisposition) {
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2, contentDisposition.length);
      fileName = decodeURI(fileName).replace(/\+/g, " ");
      return fileName;
    },
  },
  watch: {
    export_dialog() {
      if (this.export_dialog == true) this.resetItems();
    },
  },
};
</script>

<style>
.el-checkbox__label {
  display: none;
}
</style>
